import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-g_default_on",
  "use": "icon-g_default_on-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-g_default_on\"><defs><style type=\"text/css\"></style></defs><path d=\"M355.648 472.896H118.784a118.4 118.4 0 0 1-118.4-118.016V118.848A118.4 118.4 0 0 1 118.72 0.832h236.8c65.344 0 118.464 52.928 118.464 118.016v236.032a118.4 118.4 0 0 1-118.4 118.016z m0 550.72H118.784a118.4 118.4 0 0 1-118.4-118.016v-236.032a118.4 118.4 0 0 1 118.4-118.016h236.8c65.344 0 118.464 52.928 118.464 118.016v236.032a118.4 118.4 0 0 1-118.4 118.016z m548.864-550.72H667.52a118.4 118.4 0 0 1-118.4-118.016V118.848A118.4 118.4 0 0 1 667.52 0.832h236.928c65.28 0 118.4 52.928 118.4 118.016v236.032a118.4 118.4 0 0 1-118.4 118.016z m0 550.72H667.52a118.4 118.4 0 0 1-118.4-118.016v-236.032a118.4 118.4 0 0 1 118.4-118.016h236.928c65.28 0 118.4 52.928 118.4 118.016v236.032a118.4 118.4 0 0 1-118.4 118.016z\" p-id=\"5861\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/g_default_on.svg
// module id = gHDP
// module chunks = 31